import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiDownload } from 'react-icons/hi';
import { File } from '../../Models/File';

export default function ProductFiles({ data }: { data: File[] }) {
  const columnHelper = createColumnHelper<File>();
  const columns = [
    columnHelper.accessor((row) => row.fileUrl, {
      id: 'download',
      header: '',
      cell: (info) => (
        <a href={info.row.original.fileUrl!} download={info.row.original.id}>
          <button
            className='p-2'
            disabled={info.row.original.fileUrl === null ? true : false}
            style={{ color: 'blue' }}
          >
            <HiDownload size={20} />
          </button>
        </a>
      ),
      footer: (info) => info.column.id,
      enableColumnFilter: false,
      size: 25,
    }),
    columnHelper.accessor((row) => row.name, {
      id: 'name',
      header: 'Name',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
      size: 100,
    }),
    columnHelper.accessor((row) => row.fileType?.name, {
      id: 'fileTypeId',
      header: 'Type',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.dateAdded, {
      id: 'dateAdded',
      header: 'Date Added',
      footer: (info) => info.column.id,
      enableColumnFilter: false,
      size: 50,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 25,
      },
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  return (
    <div className='w-full mx-auto overflow-x-auto'>
      <PaginatedTable
        table={table}
        dataCount={data.length}
        columnResizeMode='onChange'
        showFilters={true}
      />
    </div>
  );
}
